const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export async function getGuidesMenu() {
    const response = await fetch(`${API_URL}/guides/menu`);
    if (!response.ok) {
        throw new Error('Failed to fetch guides menu');
    }
    return response.json();
}

export async function getGuideContent(guidePath) {
    const response = await fetch(`${API_URL}/guides/content?guidePath=${guidePath}`);
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Failed to fetch guide content' }));
        throw new Error(errorData.message);
    }
    return response.json();
}

export async function getGuideVotes(guidePath, token = null) {
    const headers = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_URL}/guides/votes/${encodeURIComponent(guidePath)}`, {
        headers,
    });

    if (!response.ok) {
        const errorBody = await response.json().catch(() => ({ message: 'Failed to fetch votes' }));
        throw new Error(errorBody.message);
    }
    return response.json();
}

export async function submitGuideVote(guidePath, voteType, token) {
    const response = await fetch(`${API_URL}/guides/vote`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ guidePath, voteType }),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to submit vote');
    }
    return response.json();
}
